<axs-button-text axs-size="small" class="clear-all-fields-button">
  <button type="button" (click)="clearAll.emit()">
    {{ label }}
    <ngx-axs-icon
      class="clear-all-fields-button__icon"
      axsType="trash"
      [axsDecorative]="true"
      [axsWidth]="12"
    ></ngx-axs-icon>
  </button>
</axs-button-text>

